export default {
  Requests_in_process: 'Requests in process',
  Completed_requests: 'Completed requests',
  Uploaded_documents: 'Uploaded documents',
  Rejected_applications: ' Rejected applications',
  My_profile: 'My profile',
  My_requests: 'My requests',
  Documents: 'Documents',
  Personal_documents: 'Personal documents',
  Institutional_Documents: 'Institutional Documents',
  My_desk: 'Dashboard',
  Representative_Profile: 'Representative Profile',
  Edit_profile: 'Edit profile',
  Add_company_Name: 'Add company',
  Nombre: 'Name',
  Identification_document: 'Identification document',
  Business: 'Business',
  Telephone_contact: 'Telephone contact',
  Email: 'Email',
  Edit_Company: 'Edit Company',
  Telephone: 'Telephone',
  Town: 'City',
  Tradename: 'Tradename',
  Email: 'Email',
  address: 'Address',
  Modify_company: 'Modify company',
  CONFIRMAR: '  CONFIRM',
  See_all: 'See all',
  Requests_in_process: "Requests in process",
  Completed_requests: 'Completed requests',
  // RequestCard
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
  msgrequestRequires: 'This request requires your action to continue.',
  TO_COMPLETE: 'TO COMPLETE',
  SEE_DETAIL: 'SEE DETAIL',
  Date: 'Date',
  Business: 'Business',
  application_number: ' Application Number',
  status: 'Status',

  //MyrequesMockupInfo
  MockupInProcessRequests: [
    {
      id: 1,
      percent: '60%',
      title: 'Land no objection request',
      status: 'actionRequired',
      serviceID: 1
    },
    {
      id: 2,
      percent: '90%',
      title: 'ABC test request',
      status: 'inProcess',
      serviceID: 2
    },
  ],

  MockupCompletedRequests: [
    {
      id: 1,
      title: 'Provisional Classification',
      status: 'success',
      serviceID: 3
    },
    {
      id: 2,
      title: 'Tour guides',
      status: 'success',
      serviceID: 4
    },
  ],

  MockupRejectedRequests: [
    {
      id: 1,
      title: 'Sample request',
      status: 'rejected',
      serviceID: 5
    },
  ],
  //Services requested Details

  Details: 'Details',
  ComplaintsAndclaims: ' Complaints and claims',
  Payments: 'Payments',
  Required_action: ' Required action',

  //Action Required

  TextInformation: 'Required information',
  ActionTitle: 'Information',
  DocumentRequired: ' Document required',
  document: 'Document',
  //Detail

  RequestDetails: 'Request Details',
  CostOfService: 'Cost of service',
  Project: 'Project',
  Investment_Amount: ' Investment Amount',
  Requested_by: 'Requested by',
  UploadedDocuments: 'Uploaded documents',

  //Document Request card
  DocumentName: 'Document Name',
  DocumentType: ' Document type',
  See: 'View',

  //Complaints And Claims
  claim_created: 'Claim created',
  New_claim: 'New claim',
  reasonComplaint: 'Select the reason for the complaint',
  Observations: 'Observations',
  AttachScreenshot: 'Attach file or screenshot',
  SEND: 'SEND',
  Claims: 'Claims',
  Claim: 'Claim',
  Complaint: 'Complaint',
  Payment_date: 'Payment date',
  NoCLaimAplication: 'There are no claims in this application',
  NEW_CLAIM: 'NEW CLAIM',
  claimnumber: 'Claim number',
  contactwith_us: 'Thanks by contact with us',

  //Payments
  Pay_service_tax: 'Pay service tax ',
  Pay: 'payment',
  MyPayments: 'My payments',
  PaymentID: 'Payment ID',
  Amount_Paid: 'Amount Paid',
  PaymentDate: 'Payment date',


}